"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var Trustpilot = function Trustpilot(_ref) {
  var date = _ref.date,
    title = _ref.title,
    content = _ref.content,
    author = _ref.author,
    className = _ref.className,
    starsSvg = _ref.starsSvg,
    starsCount = _ref.starsCount;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-trustpilot text-left d8-u-component-padding ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: starsSvg,
    alt: "".concat(starsCount, " stars review"),
    style: {
      width: '125px',
      marginLeft: 0
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-color-contrast-high text-sm"
  }, (0, _moment["default"])(date).format('Do MMM YY'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-sm text-component"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-md"
  }, title), /*#__PURE__*/_react["default"].createElement("p", null, content), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm d8-u-color-contrast-high"
  }, author)));
};
Trustpilot.propTypes = {
  date: _propTypes["default"].string,
  title: _propTypes["default"].string,
  content: _propTypes["default"].string,
  author: _propTypes["default"].string,
  className: _propTypes["default"].string,
  starsCount: _propTypes["default"].number,
  starsSvg: _propTypes["default"].string
};
var _default = exports["default"] = Trustpilot;